import React, { ReactNode } from 'react';
import { ChevronDownIcon } from '../uiIcons';
import './PolicyDisclosure.css';

export interface PolicyDisclosureProps {
  title: string;
  defaultOpen?: boolean;
  className?: string;
  id?: string;
  /** Rendered untouched; protected legal or policy text stays verbatim. */
  children: ReactNode;
}

/**
 * Native details/summary for secondary policy text. Anything that must be
 * visible before checkout stays outside this component.
 */
const PolicyDisclosure: React.FC<PolicyDisclosureProps> = ({ title, defaultOpen = false, className, id, children }) => (
  <details id={id} className={`luma-disclosure${className ? ` ${className}` : ''}`} open={defaultOpen || undefined}>
    <summary className="luma-disclosure__summary">
      <span className="luma-disclosure__title">{title}</span>
      <span className="luma-disclosure__chevron" aria-hidden="true">
        <ChevronDownIcon size={22} />
      </span>
    </summary>
    <div className="luma-disclosure__body">{children}</div>
  </details>
);

export default PolicyDisclosure;
